import Handlebars from "handlebars";
import assetAttachmentTemplate from "./AssetAttachment.handlebars.js";
import sectionAttachmentTemplate from "./SectionAttachment.handlebars.js";
import is_equal from "./is_equal.js";
import rows from "./rows.js";

const assetTable = '/images/compose/assetTable.svg'

Handlebars.registerPartial('AssetAttachment', assetAttachmentTemplate);
Handlebars.registerPartial('SectionAttachment', sectionAttachmentTemplate);

Handlebars.registerHelper('rows',rows)
Handlebars.registerHelper('is_equal',is_equal)

const templateString = `
{{#if sections.length}}
  <div class="sectionCard" style="margin:0;max-width: 37.5rem;">
    <!--[if mso | IE]>
      <table width=37.5rem; role="presentation" border="0" cellpadding="0" cellspacing="0">
    <![endif]-->
      {{> SectionAttachment}}
    <!--[if mso | IE]>
      </table>
    <![endif]-->
  </div>

{{else}}
  {{#if assets.length}}
    <div class="assetsGrid" style="margin:0;max-width: 37.5rem;">
      <!--[if mso | IE]>
        <table width=37.5rem; role="presentation" border="0" cellpadding="0" cellspacing="0">
      <![endif]-->  
      {{#each assets}}
        {{#rows @index 2}}
          {{> AssetAttachment}}
        {{/rows}}
      {{/each}}  
      <!--[if mso | IE]>
        </table>
      <![endif]-->
    </div>
  {{else}}
    {{#if isEmailTemplate}}
    <div>
    <img src="${assetTable}" alt="Asset Table" style="width: 27rem; height: auto;">
      </div>
    {{else}}
    <div>
    <img src="${assetTable}" alt="Asset Table" style="width: 27rem; height: auto;">
      </div>
    {{/if}}
  {{/if}}
{{/if}}
`;

const template = Handlebars.compile(templateString);

export default template;
